import { List } from 'immutable';
import StudentUnitQuizResult from './model';
import UnitQuizResult from './UnitQuizResult';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, `${val}`];
    case 'unitQuizResults':
      return [key, new List(val.map((result) => UnitQuizResult.create(result)))];
    default:
      return [key, val];
  }
};

const create = (data) => new StudentUnitQuizResult(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/UnitQuiz/model/create.js